"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var schema_1 = require("../../schema/schema");
var controller_1 = require("../../schema/controller");
var shortcut_plugin_1 = require("./shortcut-plugin");
var text_block_shortcut_1 = require("./text-block-shortcut");
var text_mark_shortcut_1 = require("./text-mark-shortcut");
var block_leaf_shortcut_1 = require("./block-leaf-shortcut");
var inline_leaf_shortcut_1 = require("./inline-leaf-shortcut");
var controller_shortcut_1 = require("./controller-shortcut");
/**
 * it build textmatcher as textblockshortcut and return a
 * TextShortcutPlugin instance
 * @param $schemaMetas
 * @param $controllerMetas
 */
function ruleBuilder($schemaMetas, $controllerMetas) {
    var rules = [];
    var $metas = __spreadArrays($controllerMetas, $schemaMetas);
    for (var _i = 0, $metas_1 = $metas; _i < $metas_1.length; _i++) {
        var $meta = $metas_1[_i];
        var name_1 = $meta.name;
        var textMatcher = ($meta instanceof controller_1.Controller ? $meta.textMatcher : $meta.config.textMatcher) || [];
        for (var _a = 0, textMatcher_1 = textMatcher; _a < textMatcher_1.length; _a++) {
            var textMatcherItem = textMatcher_1[_a];
            var regexps = textMatcherItem.matcher;
            if (!Array.isArray(regexps))
                regexps = [regexps];
            for (var _b = 0, regexps_1 = regexps; _b < regexps_1.length; _b++) {
                var regexp = regexps_1[_b];
                // Controller textMatcher
                if ($meta instanceof controller_1.Controller) {
                    rules.push(controller_shortcut_1.controllerShortcut(regexp, name_1, textMatcherItem));
                    continue;
                }
                // schema textMatcher
                switch ($meta.formatType) {
                    case schema_1.FORMAT_TYPE.BLOCK_CARD:
                        rules.push(block_leaf_shortcut_1.blockLeafShortcut(regexp, name_1, textMatcherItem));
                        break;
                    case schema_1.FORMAT_TYPE.INLINE_CARD:
                        rules.push(inline_leaf_shortcut_1.inlineLeafShortcut(regexp, name_1, textMatcherItem));
                        break;
                    case schema_1.FORMAT_TYPE.BLOCK:
                        rules.push(text_block_shortcut_1.textblockTypeTextShortcut(regexp, name_1, textMatcherItem));
                        break;
                    case schema_1.FORMAT_TYPE.INLINE:
                        rules.push(text_mark_shortcut_1.textMarkShortcut(regexp, name_1, textMatcherItem));
                        break;
                }
            }
        }
    }
    return new shortcut_plugin_1.TextShortcutPlugin(rules);
}
exports.ruleBuilder = ruleBuilder;
//# sourceMappingURL=rule-builder.js.map